<!--  模板 -->
<template>
  <div id="app">
    <div class="bg">
      <div class="min-w1200 common-header" v-if="isNew != 7">
        <!-- logo -->
        <img class="company-logo" src="~@/assets/common/logo.png" />
        <!--导航-->
        <div class="nr-nav" id="nr-nav">
          <ul>
            <li :class="isNew === 1?'active':''" class="nr-nav-lis">
              <a href="javascript:void(0)" @click="handlePath(1)">{{ $t('common.首页') }}</a>
            </li>
            <li :class="isNew === 2?'active':''" class="nr-nav-lis">
              <a href="javascript:void(0)" @click="handlePath(2)">{{ $t('common.新闻') }}</a>
            </li>
            <li :class="isNew === 3?'active':''" class="nr-nav-lis">
              <a href="javascript:void(0)" @click="handlePath(3)">{{ $t('common.方法') }}</a>
            </li>
            <li :class="isNew === 4?'active':''" class="nr-nav-lis">
              <a href="javascript:void(0)" @click="handlePath(4)">{{ $t('common.数据') }}</a>
            </li>
            <li :class="isNew === 5?'active':''" class="nr-nav-lis">
              <a href="javascript:void(0)" @click="handlePath(5)">{{ $t('common.团队') }}</a>
            </li>
            <li :class="isNew === 6?'active':''" class="nr-nav-lis">
              <a href="javascript:void(0)" @click="handlePath(6)">{{ $t('common.关于') }}</a>
            </li>
          </ul>
        </div>
        <!-- 语音  登录 -->
        <div class="company-right">
          <div class="language" @click="changeLanguage()">
            <img src="~@/assets/common/0.png" >
            <span>
              <span :style="language === 'zh-CN' ? 'font-weight: bold; color: #fff;' : ''">中</span> | 
              <span :style="language === 'en-US' ? 'font-weight: bold; color: #fff;' : ''">EN</span></span>
          </div>
          <div class="login" v-if="token">
            <span>{{ userInfo.nickname }}</span><span style="padding: 0 3px;cursor:auto">|</span><span @click="visible = true">{{ $t('common.退出') }}</span>
          </div>
          <!-- <el-popover placement="bottom" width="500" trigger="hover" v-if="token">
            <div class="popover-box">
              <div class="info">
                <div class="user">
                  <img :src="userInfo.avatar" v-if="!!userInfo.avatar">
                  <div class="tex">
                    <div class="name">{{ userInfo.nickname }} <div class="btn" @click="openAgreement(5)">{{ $t('common.充值') }}</div></div>
                    <div class="span">{{ $t('common.积分') }}：{{ userInfo.integral ? userInfo.integral : 0 }}</div>
                  </div>
                </div>
                <div class="btn-list">
                  <span @click="$router.push('/home/user')">{{ $t('common.设置') }}</span><span style="padding: 0 3px;cursor:auto">|</span><span @click="visible = true">{{ $t('common.退出') }}</span>
                </div>
              </div>
              <div class="btn-box" v-if="userInfo.sfSubscription == 1">
                <div class="btn1">
                  <span>{{ $t('common.已订阅') }}</span>
                  <span class="time">{{userInfo.subscriptionEndTime}}{{ $t('common.到期') }}</span>
                </div>
                <div class="btn" @click="openAgreement(6)">{{ $t('common.立即续费') }}</div>
              </div>
              <div class="btn-box" v-else>
                <span>{{ $t('common.暂未订阅') }}</span>
                <div class="btn" @click="openAgreement(6)">{{ $t('common.立即订阅') }}</div>
              </div>
            </div>
            <div class="login-on" slot="reference">
              <img :src="userInfo.avatar" v-if="!!userInfo.avatar">
              <span>{{ userInfo.nickname }}</span>
            </div>
          </el-popover> -->
          <div class="login" v-else>
            <span @click="handleLogin(1)">{{ $t('common.登录') }}</span><span style="padding: 0 3px;cursor:auto">|</span><span @click="handleLogin(2)">{{ $t('common.注册') }}</span>
          </div>
        </div>
      </div>
      <div>
        <router-view class="container"/><!-- 路由引用-->
      </div>
      <div class="foot">
        <div class="con">
          <div class="item" style="justify-content: center;">
            <img class="logo" src="~@/assets/common/logo.png" />
          </div>
          <div class="item">
            <div class="li"><span @click="handlePath(1)">{{ $t('common.首页') }}</span></div>
            <div class="li"><span @click="handlePath(2)">{{ $t('common.新闻') }}</span></div>
            <div class="li"><span @click="handlePath(3)">{{ $t('common.方法') }}</span></div>
            <div class="li"><span @click="handlePath(4)">{{ $t('common.数据') }}</span></div>
            <div class="li"><span @click="handlePath(5)">{{ $t('common.团队') }}</span></div>
            <div class="li"><span @click="handlePath(6)">{{ $t('common.关于') }}</span></div>
          </div>
          <div class="item">
            <div class="li">{{ $t('common.联系') }}</div>
            <div class="li" v-for="(item,key) in contactData" :key="key"><span>{{item.emailPhone}}</span></div>
            <!-- <div class="li"><span>asdsdd11220.com.cn</span></div>
            <div class="li"><span>asdsdd11220.com.cn</span></div> -->
          </div>
          <div class="item">
            <div class="li"><span @click="openAgreement(3)">{{ $t('common.免责声明') }}</span></div>
            <div class="li"><span @click="openAgreement(4)">{{ $t('common.联系我们') }}</span></div>
            <div class="li"><span @click="openAgreement(1)">{{ $t('common.注册协议') }}</span></div>
            <div class="li"><span @click="openAgreement(2)">{{ $t('common.隐私政策') }}</span></div>
          </div>
        </div>
        <div class="but">{{ $t('common.版权所有©2023 保留所有权利') }}</div>
      </div>
    </div>

    <agreement v-if="dialogVisible" ref="agreement"/>
    <contact-us v-if="lxVisible" ref="contactUs"/>

    <el-dialog :title="$t('common.提示')" :visible.sync="visible" width="400px" :before-close="() => {this.visible = false}">
      <div class="tip">
        <div class="p">{{ $t('common.确认退出当前账号？') }}</div>
        <div class="btn-list">
          <div class="btn" @click="visible = false">{{ $t('common.取消') }}</div>
          <div class="btn btn-on"><span @click="offLogin()">{{ $t('common.确认') }}</span></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import agreement from '@/components/agreement'
import contactUs from '@/components/contactUs'
import { getUserInfo, contactList } from '@/utils/api'
import Bus from '@/utils/bus'
export default {
  components: {agreement,contactUs},
  name: 'App',
  data () {
    return {
      token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
      visible: false,
      isNew: 1,
      dialogVisible: false,
      lxVisible: false,
      language: localStorage.getItem('language') || 'zh-CN',
      contactData: []
    }
  },
  created () {
    Bus.$on("infoUpdates", (data) => {
      console.log(data)
      if(this.token){
        getUserInfo().then(res => {
          this.userInfo = res
          this.$forceUpdate()
          localStorage.setItem('userInfo', JSON.stringify(res))
        })
      }
    })
    if(this.token){
      getUserInfo().then(res => {
        this.userInfo = res
        localStorage.setItem('userInfo', JSON.stringify(res))
      })
    }
    contactList().then(res => {
      console.log(res)
      this.contactData = res
    })
  },
  mounted() {},
  watch: {
    '$route': function(to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      if (['news', 'newsDetails'].indexOf(to.name) > -1) {
        this.isNew = 2
      } else if (['method'].indexOf(to.name) > -1) {
        this.isNew = 3
      } else if (['data'].indexOf(to.name) > -1) {
        this.isNew = 4
      } else if (['team'].indexOf(to.name) > -1) {
        this.isNew = 5
      } else if (['about'].indexOf(to.name) > -1) {
        this.isNew = 6
      } else if (['login'].indexOf(to.name) > -1) {
        this.isNew = 7
      } else {
        this.isNew = 1
      }
    },
    isNew(newValue, oldValue){
      console.log(newValue, oldValue)
      if(oldValue == 7){
        this.token = localStorage.getItem('token') ? localStorage.getItem('token') : null
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
      }
    }
  },
  methods: {
    // 弹框协议  1注册协议  2隐身政策  3免责声明  4联系我们
    openAgreement (type) {
      let that = this
        if(type == 4){
          that.lxVisible = true
          that.$nextTick(() => {
            that.$refs.contactUs.init()
          })
        }else{
          that.dialogVisible = true
          that.$nextTick(() => {
            that.$refs.agreement.init(type)
          })
        }
    },
    handleLogin(type){
      this.$router.push('/login/index?type=' + type)
    },
    handlePath(type) {
      switch (type) {
        case 1:
          this.isNew = 1
          this.$router.push('/')
          break
        case 2:
          this.isNew = 2
          this.$router.push('/news/index')
          break
        case 3:
          this.isNew = 3
          this.$router.push('/method/index')
          break
        case 4:
          this.isNew = 4
          this.$router.push('/data/index')
          break
        case 5:
          this.isNew = 5
          this.$router.push('/team/index')
          break
        case 6:
          this.isNew = 6
          this.$router.push('/about/index')
          break
        default:
          break
      }
    },
    changeLanguage() {
      localStorage.setItem('language', this.language === 'en-US' ? 'zh-CN' : 'en-US')
      window.location.reload()
    },
    offLogin(){
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.visible = false
      this.$router.push('/login/index?type=1')
    },
    handleOpen(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
html {
  margin: 0;
  padding: 0;
  background: #050A1B;
}
.bg{
  width: 100%;
  height: 100%;
  background: url('~@/assets/common/bg1.png') no-repeat;
  background-size: 480px 460px;
  background-position: 0 0;
}
body {
  display: block;
  margin: 0px;
  width: 100vw;
  overflow-x: hidden;
  background: #050A1B;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #7f7f7f;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(0, 0, 0, 0);
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.no-list{
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #999999;
}
.home-page {
  min-height: calc(100vh - 350px);
  padding-top: 80px;
  width: 1500px;
  margin-left: calc(50% - 750px);
}
.nav {
  padding: 30px 0 80px 0;
  font-size: 16px;
  color: #ffffff;
  .active-on {
    cursor: pointer;
  }
}

.nav-child-list {
  position: fixed;
  top: 63px;
  // width: 166px;
  width: 236px;
  background: #ebebeb;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  .nav-child-item {
    height: 60px;
    width: 100%;
    text-align: center;
    line-height: 60px;
    font-size: 16px;
    color: #333333;
    cursor: pointer;
  }
}

.min-w1200 {
  min-width:1200px;
}
.title1{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 34px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 26px;
}
.title2{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 32px;
  color: #ffffff;
  margin-bottom: 40px;
}
.container {
  width: 100%;
  min-height: calc(100vh - 350px);
  background: #050A1B;
}
.common-header {
  // background-color: #333;
  background: #050A1B;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 500;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.company-logo {
  // width: 110px;
  height: 60px;
  position: absolute;
  left: 60px;
  top: 50%;
  transform: translateY(-50%);
}

.company-right {
  position: absolute;
  right: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 19px;
  .login {
    min-width: 132px;
    height: 32px;
    background: rgba($color: #ffffff, $alpha: 0.09);
    border-radius: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    span{
      cursor: pointer;
    }
  }
  .language {
    display: flex;
    align-items: center;
    margin-right: 60px;
    cursor: pointer;
    color: #ccc;
    img {
      width: 16px;
      height: 16px;
      margin-right: 13px;
    }
  }
  .login-on{
    min-width: 132px;
    height: 32px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img{
      width: 38px;
      height: 38px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
}

.popover-box{
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
    padding: 12px;
    .info{
      width: 100%;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .user{
        flex-grow: 1;
        display: flex;
        align-items: center;
        img{
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .tex{
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name{
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            display: flex;
            align-items: center;
            .btn{
              margin-left: 5px;
              min-width: 40px;
              padding: 0 10px;
              height: 20px;
              border-radius: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              color: #ffffff;
              font-weight: initial;
              cursor: pointer;
              background: linear-gradient(90deg, #4508EE 0%, #701FF5 100%);
            }
          }
          .span{
            font-size: 14px;
            color: #333333;
          }
        }
      }
      .btn-list{
        flex-shrink: 0;
        font-size: 14px;
        color: #333333;
        span{
          cursor: pointer;
        }
      }
    }
    .btn-box{
      width: 100%;
      height: 60px;
      background: rgba(29, 36, 49, 0.06);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;
      font-size: 16px;
      color: #4D0CF0;
      font-weight: bold;
      .btn{
        flex-shrink: 0;
        min-width: 92px;
        height: 36px;
        border-radius: 36px;
        padding: 0 10px;
        background: #4D0CF0;
        font-size: 16px;
        font-weight: initial;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .btn1{
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        .time{
          padding-top: 6px;
          font-size: 14px;
          font-weight: initial;
        }
      }
    }
  }
.nr-nav {
  width: 55%;
}
ul,li,li a{
  text-decoration:none;
  list-style:none
}
.nr-nav ul .nr-nav-lis {
  position: relative;
  line-height: 64px;
  float: left;
  font-size: 26px;
  font-family: Microsoft YaHei;
}
.nr-nav .active ::after {
  content: "";
  position: absolute;
  width: 14px;
  height: 4px;
  border-radius: 2px;
  top: 15px;
  left: 0;
  background: linear-gradient(180deg, #4508EE 0%, #701FF5 100%);
}
.nr-nav ul {
  display: flex;
  justify-content: space-between;
  padding: 0;
}
.nr-nav ul .active a{
  font-weight: bold;
  color: #fff !important;
}
.nr-nav ul .jrdxd img{
  width: 188px;
  margin-top: -20px;
}
.nr-nav ul .nr-nav-lis a:hover {
  cursor:pointer;
  color: #fff;
  font-weight: bold;
}
.nr-nav ul .nr-nav-lis a{
  color:#ccc;
  // font-weight: bold;
}

// .el-dialog__header  {
//   padding: 10px 10px 10px 30px;
//   background-color: #f9f9f9;
//   .el-dialog__headerbtn {
//     top: 15px;
//   }
// }

// .el-dialog__body {
//   padding: 20px;
// }

.foot{
  // position: fixed;
  // bottom: 0;
  // left: 0;
  // z-index: 500;
  background: #0C1229;
  width: 100%;
  height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .con{
    width: 100%;
    padding: 50px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .item{
      width: 292px;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      border-right: 1px solid rgba($color: #ffffff, $alpha: 0.44);
      &:last-child{
        border-right: none;
      }
      .logo{
        width: 180px;
      }
      .li{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #ffffff;
        padding: 6px 0;
        span{
          cursor: pointer;
        }
      }
    }
  }
  .but{
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #ffffff;
  }
}


  // /deep/ .el-dialog__header{
  //   padding: 20px 30px !important;
  //   background: #F9F9F9 !important;
  //   border-bottom: 1px solid #E2E2E2 !important;
  // }
  // /deep/ .el-dialog__body{
  //   padding: 20px 10px !important;
  // }
  .tip{
    width: 100%;
    // padding: 20px 50px;
    .p{
      font-size: 20px;
      color: #333333;
      text-align: center;
      margin-bottom: 70px;
    }
    .btn-list{
      width: 100%;
      display: flex;
      justify-content: space-around;
      .btn{
        width: 140px;
        height: 42px;
        border-radius: 42px;
        border: 1px solid #D8D8D8;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        font-size: 16px;
        cursor: pointer;
      }
      .btn-on{
        color: #ffffff;
        background: linear-gradient(96deg, #4508EE 0%, #701FF5 100%); 
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue